var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentCallHangup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28C6.25 28 0 21.74 0 14S6.25 0 14 0c7.74 0 14 6.26 14 14s-6.26 14-14 14z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.26 12.39c-.41-.13-.83-.22-1.25-.29-.43-.06-.86-.1-1.29-.1-.42 0-.85.04-1.28.1-.42.07-.84.16-1.25.29v1.69c.01.05 0 .1-.01.15-.01.05-.03.09-.06.14-.03.04-.06.07-.1.1-.04.03-.09.06-.13.07-.15.07-.3.15-.44.23-.15.09-.29.18-.42.27-.14.1-.27.2-.39.31-.13.11-.25.22-.37.34-.04.05-.1.1-.17.13-.06.03-.14.04-.21.04-.07 0-.14-.01-.21-.04a.7.7 0 01-.17-.13l-1.31-1.3a.567.567 0 01-.12-.18.465.465 0 010-.42c.03-.06.07-.12.12-.17.86-.86 1.88-1.54 3-2 1.11-.47 2.31-.7 3.52-.7 1.22 0 2.42.23 3.53.7 1.12.46 2.14 1.14 3 2 .05.05.09.11.12.17a.465.465 0 010 .42c-.03.07-.07.13-.12.18l-1.35 1.34c-.05.05-.1.1-.17.13s-.14.04-.21.04c-.07 0-.14-.01-.21-.04a.453.453 0 01-.17-.13 5.96 5.96 0 00-.37-.34c-.13-.1-.26-.21-.39-.3-.14-.1-.28-.19-.42-.28-.14-.08-.29-.16-.44-.23-.04-.03-.08-.06-.11-.09-.03-.04-.07-.07-.09-.11a.539.539 0 01-.07-.13c-.02-.04-.03-.09-.04-.13l.05-1.73z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentCallHangup);
export default __webpack_public_path__ + "static/media/recent-call-hangup.01428d24.svg";
export { ForwardRef as ReactComponent };